// Sets compatible with the backend's PasswordSchema regex.
// (Excludes ambiguous chars like 0/O/1/l/I for readability.)
const UPPER = 'ABCDEFGHJKLMNPQRSTUVWXYZ';
const LOWER = 'abcdefghijkmnpqrstuvwxyz';
const NUMS = '23456789';
const SYMS = '!@#$%^&*()-_=+[]{};:,.?';
const ALL = UPPER + LOWER + NUMS + SYMS;

export const PASSWORD_LENGTH = 14;

const pickFrom = (chars: string): string => {
  const buf = new Uint32Array(1);
  crypto.getRandomValues(buf);
  return chars.charAt(buf[0] % chars.length);
};

const shuffle = <T>(arr: T[]): T[] => {
  const copy = [...arr];
  for (let i = copy.length - 1; i > 0; i -= 1) {
    const buf = new Uint32Array(1);
    crypto.getRandomValues(buf);
    const j = buf[0] % (i + 1);
    [copy[i], copy[j]] = [copy[j], copy[i]];
  }
  return copy;
};

// Generates a random password that satisfies the backend regex:
// at least 14 chars + 1 upper + 1 lower + 1 digit + 1 special character.
// Unit, side-effect-free. Reusable.
export const generatePassword = (length = PASSWORD_LENGTH): string => {
  const required = [pickFrom(UPPER), pickFrom(LOWER), pickFrom(NUMS), pickFrom(SYMS)];
  const rest = Array.from({ length: Math.max(length - required.length, 0) }, () => pickFrom(ALL));
  return shuffle([...required, ...rest]).join('');
};
